import { fork, take, call, put } from 'redux-saga/effects'

import types from './types'
import { apiDirect } from '../../api/generic'
import { fetchSubscriptionCardInfoRes, updateSubscriptionCardInfoRes } from './actions'


export function* doGetCardInfo() {
    while (true) {
      // console.log('is called')
      const { payload } = yield take(types.GET_SUBSCRIPTION_CARD_INFO)
      const response = yield call(apiDirect, payload)
      yield put(fetchSubscriptionCardInfoRes(response))
    }
}

export function* doUpdateCardInfo() {
    while (true) {
      // console.log('is called')
      const { payload } = yield take(types.UPDATE_SUBSCRIPTION_CARD_INFO)
      const response = yield call(apiDirect, payload)
      yield put(updateSubscriptionCardInfoRes(response))
    }
}

function* payment() {
    yield fork(doGetCardInfo)
    yield fork(doUpdateCardInfo)
  }
  
  
  export default payment